import React from 'react';
import { CONTACT } from '../data';
import './Contact.css';

export default function Contact() {
  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact__inner">
          <div className="contact__content">
            <span className="section-eyebrow">Work Together</span>
            <h2 className="section-title contact__title">Have a martech challenge?</h2>
            <p className="contact__text">
              Whether you're starting from scratch, optimizing an existing stack, or preparing for a major transformation — let's talk.
            </p>
          </div>
          <div className="contact__action">
            <a href={`mailto:${CONTACT.email}`} className="contact__email-btn">
              {CONTACT.email}
              <span className="contact__email-arrow">↗</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
